import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import classNames from "classnames";
import { useNotificationPopups } from "hooks/useNotificationPopups";
import Footer from "components/organisms/Footer";
import GoTop from "components/atoms/GoTop";
import HeaderContainer from "containers/organisms/HeaderContainer";
import ProfileSidebarContainer from "containers/organisms/ProfileSidebarContainer";
import url from "url/index";
import { useSelector } from "react-redux";
import TabBarContainer from "../../../containers/molecules/TabBarContainer";
import * as authSelectors from "../../../redux/auth/selectors";
import "./styles.sass";

const ProfileLayout = () => {
  const location = useLocation();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  useNotificationPopups();
  const scrollRef = useRef<HTMLDivElement>(null);
  const isLoyalty = location.pathname.includes("loyalty");
  const isProfile =
    location.pathname.endsWith("profile") ||
    location.pathname.endsWith("profile/");

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location.pathname, scrollRef]);

  const layoutClass = classNames("ProfileLayout", {
    // eslint-disable-next-line camelcase
    ProfileLayout__grey: isLoyalty || isProfile,
    // eslint-disable-next-line camelcase
    ProfileLayout__white: VITE_APP_PROJECT_NAME === "glory",
    // eslint-disable-next-line camelcase
    ProfileLayout__loyalty: isLoyalty,
  });

  const footerClass = classNames("ProfileLayout__footer", {
    hide: location.pathname.includes(`/${url.config.profile.root}`),
  });

  const containerClass = classNames("ProfileLayout__container", {
    scrollContent: location.pathname.includes(`/${url.config.profile.bonus}`),
    auth: isAuthenticated,
  });

  const headerClass = classNames("ProfileLayout__header", {
    auth: isAuthenticated,
  });

  const classNameContent = classNames("ProfileLayout__content", {
    isLoyalty,
    isProfile,
  });

  return (
    <div className={layoutClass} id="profile-layout">
      <div className={containerClass}>
        <div className={headerClass}>
          <div />
          <HeaderContainer />
        </div>
        <div className="ProfileLayout__sidebar">
          <ProfileSidebarContainer />
        </div>
        <div className={classNameContent} ref={scrollRef}>
          <div className="ProfileLayout__content_container">
            <Outlet />
            {!isLoyalty && <GoTop />}
          </div>
        </div>
        <div className={footerClass}>
          <Footer />
        </div>
        <TabBarContainer />
      </div>
    </div>
  );
};

export default ProfileLayout;
